import { DiceType } from '../../../api/DnD/dices';
import { DiceDescription, DiceInfo, DiceOptions } from '../diceTypes';
import { FACE_TEXTS } from '../r3fConstants';
import { createGeometry, createShape } from '../utils';

const createDescription = (): DiceDescription => {
  const p = (1 + Math.sqrt(5)) / 2;
  const q = 1 / p;

  const desc: DiceDescription = {
    type: DiceType.d12,
    tab: 0.2,
    af: -Math.PI / 4 / 2,
    // chamfer: 0.968,
    chamfer: 1,
    vertices: [
      [0, q, p],
      [0, q, -p],
      [0, -q, p],
      [0, -q, -p],
      [p, 0, q],
      [p, 0, -q],
      [-p, 0, q],
      [-p, 0, -q],
      [q, p, 0],
      [q, -p, 0],
      [-q, p, 0],
      [-q, -p, 0],
      [1, 1, 1],
      [1, 1, -1],
      [1, -1, 1],
      [1, -1, -1],
      [-1, 1, 1],
      [-1, 1, -1],
      [-1, -1, 1],
      [-1, -1, -1],
    ],
    faces: [
      [0, 12, 8, 10, 16, 1],
      [1, 17, 10, 8, 13, 2],
      [16, 10, 17, 7, 6, 3],
      [13, 8, 12, 4, 5, 4],
      [6, 18, 2, 0, 16, 5],
      [2, 14, 4, 12, 0, 6],
      [3, 19, 7, 17, 1, 7],
      [1, 13, 5, 15, 3, 8],
      [6, 7, 19, 11, 18, 9],
      [5, 4, 14, 9, 15, 10],
      [18, 11, 9, 14, 2, 11],
      [15, 9, 11, 19, 3, 12],
    ],
    scaleFactor: 0.9,
    values: 12,
    faceTexts: FACE_TEXTS,
    textMargin: 1.0,
    mass: 350,
  };

  return desc;
};

const description = createDescription();

const options: DiceOptions = {
  size: 2.5,
  backColor: '#e0ca3c',
  fontColor: '#2d3047',
};

export const D12: DiceInfo = {
  description,
  options,
  geometry: createGeometry(options.size, description),
  args: createShape(description, options.size),
};
